import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { Col, Divider, message, Modal, Row } from 'antd';
import CommonDialog from '../Dialog';
import { User } from '../../redux/type';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import AsArrived from './components/AsArrived';
import Control from './components/Control';
import ReStart from './components/ReStart';
import StopOrRecovery from './components/StopOrRecovery';
import PassTrafficLight from './components/PassTrafficLight';
import JiraKey from './components/Jira';
import WebTerminalBtn from './components/WebTerminalBtn';
import { getPermissionById, isEmpty } from '../../utils';
import { IssueType, PermissionButton } from '../../utils/constant';
import { RootState } from '../../redux/store';
import PopoverModel from '../PopoverModel/PopoverModel';
import {
  PopoverTypeEnum,
  TakeOverSource,
  TakeOverSourceMap,
} from './utils/dialog';
import qs from 'qs';
import ActionType from '../../redux/action/control';
import { HttpStatusCode } from '../../fetch/core/constant';
import {
  actionSendHttpRequest,
  actionSendSocketData,
} from '../../redux/action';
import RemoveStop from './components/RemoveStop';
import { formatFetchUrl } from '../../fetch/bussiness/util';
import { addGlobalEventListener } from '../../utils/emit';
import ResetGPS from './components/ResetGPS';
import CompleteIssue from './components/CompleteIssue';
import TransferIssue from './components/TransferIssue';
import OnHoldIssue from './components/OnHoldIssue';
import DiscardIssue from './components/DiscardIssue';
import CallFrontliner from './components/CallFrontliner';
import { TakeOverStatus } from '@/views/PatrolMode/types';
interface Props {
  userInfo: User | null;
  license: string | null;
  openJiraModal: boolean; // 事故排查-提报jira
  selectAccident: any;
  closeJiraModalCb: AnyFunc; // 事故排查-关闭弹窗回调
  disabled?: boolean; // 是否为三方车
}

const remoteSuccessMessageMap = new Map([
  ['REMOTE_REQUEST_EMERGENCY_STOP', '车辆急停成功'],
  ['REMOTE_REQUEST_RECOVERY', '车辆已恢复'],
  ['REMOTE_REQUEST_REMOTE_RESTART', '车辆已重启'],
  ['REMOTE_REQUEST_AS_ARRIVED', '视同到达成功'],
  ['REMOTE_REQUEST_PASS_LIGHT', '一键通过红绿灯成功'],
  ['REMOTE_CONTROL_POWER_REBOOT', '指令已下发'],
  ['REMOTE_CONTROL_POWER_OFF', '指令已下发'],
]);

const Keys = (props: Props) => {
  const dispatch = useDispatch();
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo,
  );
  const login = useSelector((state: RootState) => state.login);
  const control = useSelector((state: RootState) => state.response);
  const issueList = useSelector(
    (state: RootState) => state.workOrder.issueList,
  );
  const { vehicleRealTimeInfo, takeoverIssueData } = singleVehiclePageInfo;
  const { systemState, schedule } = vehicleRealTimeInfo;
  const { license } = props;
  const jiraKeyRef = useRef(null);
  const timerRef = useRef<any>(null);
  const operateResultRef = useRef<any>(null);
  const countRef = useRef<number>(0);
  const keyListRef = useRef<any>(null);
  const [timerCount, setTimerCount] = useState<any>(0);
  const query = qs.parse(window.location.search.split('?')[1]);
  const vehicleName = query && query.license;
  const [isShowModel, setIsShowModel] = useState(false);
  const [isStoped, setIsStoped] = useState(false); // 是否按了急停按钮
  const [operatorIsSelf, setOperatorIsSelf]: any = useState(); // 是否是本人操作
  const [configTip, setConfigTip] = useState(''); // 弹窗提示文字
  const [popoverModelDetail, setPopoverModelDetail] = useState<{
    position: any;
    visible: boolean;
    popoverType: PopoverTypeEnum;
  }>({
    position: null,
    visible: false,
    popoverType: PopoverTypeEnum.WORK_ORDER_POPOVER,
  });

  const navigate = useNavigate();
  const config = {
    iconName: 'warningIcon', // 弹窗icon
    isOnlyBtn: false,
    show: isShowModel, // isShow弹窗
    submitBtnTxt: '确认',
    tipType: configTip, // 提示信息
  };

  const controlPermission = getPermissionById(
    PermissionButton.SPV_CONTROL_LIST,
  );
  //  无权限不可用    系统状态：失联和离线状态下急停按钮不可用  虚拟摇杆状态监控端不可用
  const disabled =
    props.disabled ||
    !controlPermission ||
    ['CONNECTION_LOST', 'OFFLINE'].includes(systemState) ||
    takeoverIssueData?.takeOverSource == TakeOverSource.MINI_MONITOR ||
    (takeoverIssueData?.takeOverSource === TakeOverSource.REMOTE_JOYSTICK &&
      takeoverIssueData?.takeOverStatus === TakeOverStatus.TAKEOVER);
  const mileageToNextStop =
    schedule && schedule.globalMileage - schedule.finishedMileage;
  const jiraPermission = getPermissionById(PermissionButton.SPV_JIRA_REPORT);
  const terminalPermission = getPermissionById(
    PermissionButton.SPV_COMMAND_TERMINAL,
  );
  const ticketOperationPermission =
    getPermissionById(PermissionButton.TICKET_OPERATION) &&
    issueList?.filter((issue: any) => issue.issueType === IssueType.OPS);
  useEffect(() => {
    if (takeoverIssueData && takeoverIssueData.takeOverUser) {
      setIsStoped(true);
      if (
        login.user &&
        ((login.user.username == takeoverIssueData.takeOverUser &&
          takeoverIssueData?.takeOverSource == TakeOverSource.MONITOR) ||
          takeoverIssueData?.takeOverStatus === TakeOverStatus.TEMPORARY)
      ) {
        setOperatorIsSelf(true);
      } else {
        setOperatorIsSelf(false);
      }
    } else {
      setIsStoped(false);
    }
  }, [takeoverIssueData]);

  useEffect(() => {
    if (props.openJiraModal) {
      changePopoverType(jiraKeyRef);
    }
  }, [props.openJiraModal]);

  // 指令弹窗点击确认后，下发指令
  const HandleDialogWarning = (isShow: boolean, eventType: null | string) => {
    setIsShowModel(!isShowModel);
    if (isShow) {
      if (eventType == 'remoteControl') {
        navigate(
          '/app/remoteControl?&license=' +
            license +
            '&userName=' +
            login.userName,
        );
      } else {
        sendRemoteCommand(eventType || '');
      }
    }
  };

  const onShowMessage = (e: string) => {
    setIsShowModel(!isShowModel);
    setConfigTip(e);
  };
  // 问题提报popover展示
  const changePopoverType = (value: any) => {
    setPopoverModelDetail({
      position: value && value.current,
      visible: true,
      popoverType: PopoverTypeEnum.JIRA_SUBMIT_POPOVER,
    });
  };
  // 关闭popover
  const closeCallBack = () => {
    if (props.openJiraModal) {
      props.closeJiraModalCb();
    }
    setPopoverModelDetail({
      ...popoverModelDetail,
      visible: false,
    });
  };
  const popStyle = {
    display: popoverModelDetail.visible ? 'block' : 'none',
    left: `${
      popoverModelDetail.position &&
      popoverModelDetail.position.offsetLeft - 825
    }px`,
  };

  const clickJiraKey = () => {
    if (!jiraPermission || !!props.disabled) {
      return;
    }
    changePopoverType(jiraKeyRef);
  };

  // 指令响应回调处理
  const onMessageCallback = (data: any, payload: any) => {
    const res = data;
    if (res.code == HttpStatusCode.Success) {
      message.success(remoteSuccessMessageMap.get(res.data.eventType));
      if (res.data.eventType == ActionType.REMOTE_REQUEST_EMERGENCY_STOP) {
        setOperatorIsSelf(true);
        setIsStoped(true);
      } else if (res.data.eventType == ActionType.REMOTE_REQUEST_RECOVERY) {
        setIsStoped(false);
        setOperatorIsSelf(false);
      }
      setConfigTip(''); // 提示文字恢复默认值
    } else {
      message.error(res.message);
    }
  };

  /**
   * 下发操作指令
   * @param {string} pathURI  指令请求path
   */
  const sendRemoteCommand = (pathURI: string) => {
    const operateData: HTTPFetchActionParams = {
      method: 'POST',
      path: pathURI,
      nextActionFunc: onMessageCallback,
      body: {
        vehicleName: vehicleName,
        timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      },
      actionType: '',
    };
    dispatch(actionSendHttpRequest(operateData));
  };

  const startInterval = () => {
    const fn = () => {
      clearTimeout(timerRef.current);
      countRef.current++;
      if (countRef.current > 120) {
        clearTimeout(timerRef.current);
        countRef.current = 0;
        timerRef.current = null;
        setTimerCount(0);
        return;
      }
      setTimerCount(countRef.current);
      timerRef.current = setTimeout(fn, 1000);
    };
    timerRef.current = setTimeout(fn, 1000);
  };

  const formatResponse = (response: any) => {
    const { operateTimestamp } = response.data;
    if (response.data.state != 'FAIL') {
      const now = Date.now();
      const operateTime = new Date(operateTimestamp).getTime();
      const operatRedult = {
        timerCount: Math.ceil((now - operateTime) / 1000),
        operateTime: new Date(operateTimestamp).getTime(),
      };
      operateResultRef.current = operatRedult;
      return operatRedult;
    }
    return null;
  };

  const getTerminalList = () => {
    const data = {
      eventType: ActionType.REMOTE_WEB_TERMINAL_TOOL,
      data: {
        vehicleName,
      },
    };
    dispatch(actionSendSocketData(JSON.stringify(data)));
  };

  useEffect(() => {
    // 监听上下电接口响应
    addGlobalEventListener('Control_Message', (arg: any) => {
      if (!operatorIsSelf) {
        return;
      }
      const { messageLevel, title, messageText } = arg;
      if (messageLevel === 'INFO') {
        message.success(title);
      } else {
        Modal.error({
          title: title,
          content: messageText,
          className: 'my-modal',
          onOk: () => {
            clearTimeout(timerRef.current);
            setTimerCount(0);
            countRef.current = 0;
            timerRef.current = null;
          },
        });
      }
    });
    // 监听上下电成功响应 开始计时
    addGlobalEventListener('POWER_OFF_SUCCESS', (arg: any) => {
      if (!operatorIsSelf) {
        return;
      }
      const data = formatResponse(arg);
      if (data) {
        countRef.current = data.timerCount;
        startInterval();
      }
    });

    // 监听页面显示 同步不同窗口的计时数
    document.addEventListener('visibilitychange', function () {
      if (!operatorIsSelf) {
        return;
      }
      if (!document.hidden) {
        if (operateResultRef.current) {
          countRef.current = Math.ceil(
            (Date.now() - operateResultRef.current.operateTime) / 1000,
          );
        }
      }
    });

    return () => {
      timerRef.current && clearTimeout(timerRef.current);
    };
  }, [operatorIsSelf]);
  return (
    <>
      <div className='tools-view'>
        {timerCount != 0 && operatorIsSelf && (
          <MaskCmp text={`远程下电中 ${timerCount}s`} color='#FF9E0B' />
        )}
        {isStoped &&
          (!operatorIsSelf ||
            (operatorIsSelf &&
              takeoverIssueData?.takeOverStatus ===
                TakeOverStatus.TEMPORARY)) && (
            <MaskCmp
              text={`${
                takeoverIssueData && takeoverIssueData.takeOverUser
              }于${takeoverIssueData && TakeOverSourceMap.get(takeoverIssueData.takeOverSource)?.name} ${takeoverIssueData.takeOverStatus === TakeOverStatus.TAKEOVER ? '接管中...' : '临时停车中...'}`}
            />
          )}
        <ul className='list' ref={keyListRef}>
          <StopOrRecovery
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            operatorIsSelf={operatorIsSelf}
            disabled={disabled}
            operateRequest={(eventType) => {
              sendRemoteCommand(eventType);
            }}
            onShowMessage={(name) => {
              onShowMessage(name);
            }}
          />
          <Control
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            disabled={disabled}
            takeOverSource={takeoverIssueData?.takeOverSource}
            operatorIsSelf={operatorIsSelf}
            onShowMessage={(name) => {
              onShowMessage(name);
            }}
          />
          <PassTrafficLight
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            operatorIsSelf={operatorIsSelf}
            disabled={disabled}
            onShowMessage={(value) => {}}
          />
          <AsArrived
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            operatorIsSelf={operatorIsSelf}
            disabled={disabled}
            mileageToNextStop={mileageToNextStop}
            onShowMessage={(name) => {
              onShowMessage(name);
            }}
          />
          <RemoveStop
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            disabled={disabled}
            operatorIsSelf={operatorIsSelf}
            onShowMessage={(name) => {}}
          />
          <ReStart
            takeOverStatus={takeoverIssueData.takeOverStatus}
            isStoped={isStoped}
            disabled={disabled}
            operatorIsSelf={operatorIsSelf}
            onShowMessage={(name) => {}}
          />
          <ResetGPS
            isStoped={isStoped}
            disabled={disabled}
            operatorIsSelf={operatorIsSelf}
            vehicleName={vehicleName}
            userName={login.userName}
          />
          <WebTerminalBtn
            vehicleName={vehicleName}
            userName={login.userName}
            getTerminalList={getTerminalList}
            terminalList={control.terminalList}
            disabled={!terminalPermission || !!props.disabled}
          />
        </ul>
        <div className='mini-operate'>
          <Row className='mini-list'>
            <Col>
              <CompleteIssue
                vehicleName={vehicleName}
                disabled={!ticketOperationPermission || !!props.disabled}
              />
              <DiscardIssue
                vehicleName={vehicleName}
                disabled={!ticketOperationPermission || !!props.disabled}
              />
            </Col>
            <Col>
              <TransferIssue
                vehicleName={vehicleName}
                disabled={!ticketOperationPermission || !!props.disabled}
              />
              <OnHoldIssue
                vehicleName={vehicleName}
                disabled={!ticketOperationPermission || !!props.disabled}
              />
            </Col>
          </Row>
          <Divider
            type='vertical'
            style={{
              height: '80%',
              backgroundColor: 'rgba(255,255,255,0.2)',
            }}
          />
          <Row className='mini-list'>
            <Col>
              <CallFrontliner
                disabled={!!props.disabled}
                vehicleName={vehicleName}
              />
              <div
                className={'mini-item'}
                ref={jiraKeyRef}
                onClick={clickJiraKey}
              >
                <JiraKey disable={!jiraPermission || !!props.disabled} />
              </div>
              <div className='work-order-content' style={popStyle}>
                {popoverModelDetail.visible && (
                  <PopoverModel
                    visible={popoverModelDetail.visible}
                    popoverType={popoverModelDetail.popoverType}
                    position={popoverModelDetail.position}
                    openJiraModal={props.openJiraModal}
                    selectAccident={props.selectAccident}
                    closeCallBack={closeCallBack}
                  ></PopoverModel>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <CommonDialog
          config={config}
          // eslint-disable-next-line new-cap
          handleAction={(value) =>
            HandleDialogWarning(value.isShow, value.eventType)
          }
        ></CommonDialog>
      </div>
    </>
  );
};

export const MaskCmp = (props: {
  text: string;
  color?: string;
  width?: string;
  left?: string;
}) => {
  return (
    <i
      className='mask-wrapper'
      style={{
        color: props.color || '#FF574D',
        left: props.left,
      }}
    >
      {props.text}
    </i>
  );
};
export default React.memo(Keys);
